module.exports = __webpack_public_path__ + "img/us.8abed18f.png";